export const calculateItemValues = (item: any) => {
    const quantity = Math.max(1, Math.min(10000, Math.floor(item.quantity || 1)));

    // Total selling price before discount
    const totalSellingPrice = Math.round(item.selling_price * quantity);

    // Calculate total discount
    let totalDiscount = 0;
    if (item.discount_type === "%") {
        totalDiscount = Math.round(((item.discount || 0) / 100) * totalSellingPrice);
    } else if (item.discount_type === "flat" || item.discount_type === "₹") {
        totalDiscount = Math.round(item.discount || 0); // flat discount applied on total
    }

    // Cap discount so it doesn't exceed total
    totalDiscount = Math.max(0, Math.min(totalDiscount, totalSellingPrice));

    // Taxable value after discount
    const taxable_value = Math.round(totalSellingPrice - totalDiscount);

    // Tax amount
    // const tax_amount = Math.max((taxable_value * (item.tax_rate || 0)) / 100, 0);
    const tax_amount = 0;


    // Final amount (after discount + tax)
    const item_amount = Math.round(taxable_value + tax_amount);

    return {
        ...item,
        discount: item.discount, // keep original discount value
        tax_rate: item.tax_rate,
        gst: item.tax_rate,
        quantity,
        taxable_value,
        tax_amount,
        item_amount,
    };
};